// extracted by mini-css-extract-plugin
module.exports = {"link":"_02712f2b3b--link--NlQ12"};